<template>
    <div class="container-fluid">
    <br />
    <b-row>
      <b-col class="col-sm-12 col-xl-2">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-user"></i> Cadastros por Dia
          </div>
          <div class="card-body">
            <ul class="list-group" v-if="dashboardData">
              <li v-for="item in dashboardData.dailySignUpInfo" v-bind:key="item.date" class="list-group-item">{{item.date| moment("DD/MM/YYYY")}}: <b>{{item.amount}}</b></li>
            </ul>
            <Spinner v-else />
          </div>
        </div>
      </b-col>
      <b-col class="col-sm-12 col-xl-2">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-user"></i> Free virou Premium
          </div>
          <div class="card-body">
            <ul class="list-group" v-if="dashboardData">
              <li v-for="item in dashboardData.becamePremium" v-bind:key="item.date" class="list-group-item">{{item.date| moment("DD/MM/YYYY")}}: <b>{{item.amount.length}}</b></li>
            </ul>
            <Spinner v-else />
          </div>
        </div>
      </b-col>
      <b-col class="col-sm-12 col-xl-2">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-user"></i> Premium Renovou
          </div>
          <div class="card-body">
            <ul class="list-group" v-if="dashboardData">
              <li v-for="item in dashboardData.renewed" v-bind:key="item.date" class="list-group-item">{{item.date| moment("DD/MM/YYYY")}}: <b>{{item.amount}}</b></li>
            </ul>
            <Spinner v-else />
          </div>
        </div>
      </b-col>
      <b-col class="col-sm-12 col-xl-2">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-user"></i> Ebooks Gerados por Dia
          </div>
          <div class="card-body">
            <ul class="list-group" v-if="dashboardData">
              <li v-for="item in dashboardData.ebooksGeneratedInfo" v-bind:key="item.date" class="list-group-item">{{item.date| moment("DD/MM/YYYY")}}: <b>{{item.amount}}</b></li>
            </ul>
            <Spinner v-else />
          </div>
        </div>
      </b-col>
      <b-col class="col-sm-12 col-xl-2">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-user"></i> Ebooks Criados por Dia
          </div>
          <div class="card-body">
            <ul class="list-group" v-if="dashboardData">
              <li v-for="item in dashboardData.ebooksRequestedInfo" v-bind:key="item.date" class="list-group-item">{{item.date| moment("DD/MM/YYYY")}}: <b>{{item.amount}}</b></li>
            </ul>
            <Spinner v-else />
          </div>
        </div>
      </b-col>
      <!--<b-col class="col-sm-12 col-xl-2">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-user"></i> Primeiros Pagamentos por Dia
          </div>
          <div class="card-body">
            <ul class="list-group" v-if="payments && payments.length">
              <li v-for="item in payments" v-bind:key="item.date" class="list-group-item">{{item.date | moment("DD/MM/YYYY")}}: <b>{{item.payments}}</b></li>
            </ul>
            <Spinner v-else />
          </div>
        </div>
      </b-col>-->
      <!--<b-col class="col-sm-12 col-xl-2">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-user"></i> Primeiros Pagamentos por Mes
          </div>
          <div class="card-body">
            <ul class="list-group" v-if="paymentsMonth && paymentsMonth.length">
              <li v-for="item in paymentsMonth" v-bind:key="item.date" class="list-group-item">{{item.date | moment("DD/MM/YYYY")}}: <b>{{item.payments}}</b></li>
            </ul>
            <Spinner v-else />
          </div>
        </div>
      </b-col>-->
      <!--<b-col class="col-sm-12 col-xl-2" >
        <div class="card">
          <div class="card-header">
            <i class="fa fa-user"></i> Cadastros por Mês
          </div>
          <div class="card-body">
            <ul class="list-group" v-if="dashboardData">
              <li v-for="item in dashboardData.monthlySignUpInfo" v-bind:key="item.date" class="list-group-item">{{item.date| moment("MM/YYYY")}}: <b>{{item.amount}}</b></li>
            </ul>
            <Spinner v-else />
          </div>
        </div>
      </b-col>-->
      <b-col class="col-sm-12 col-xl-2">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-pencil"></i> Creation
          </div>
          <div class="card-body">
            <ul class="list-group" v-if="creations">
              <li class="list-group-item">Solicitados: <b>{{this.creations.starting.length}}</b></li>
              <li class="list-group-item">Sem Legenda: <b>{{this.creations.noSubtitle.length}}</b></li>
              <li class="list-group-item">Com Legenda: <b>{{this.creations.hasSubtitle.length}}</b></li>
              <li class="list-group-item">Arte Criada: <b>{{this.creations.hasArt.length}}</b></li>
              <li class="list-group-item">Em Análise: <b>{{this.creations.underReview.length}}</b></li>
            </ul>
            <Spinner v-else />
          </div>
        </div>
      </b-col>
    </b-row>
    <br />
  </div>
</template>

<script>
import service from "../service";
import Spinner from "./Spinner";
import CreationList from "./CreationList";

export default {
  name: 'AdminDashboard',
  data: () => {
    return {
      loadingData: true,
      dashboardData: undefined,
      dashboardCategories: undefined,
      creations: undefined,
      loadingFirstPaymentData: true,
      paymentsMonth: [],
      payments: []
    };
  },
  methods: {
    getDashboardData: function() {
      service.getAdminDashboardData().then(response => {
        this.dashboardData = response;
      });
    },
    getDashboardCategories: function() {
      service.getAdminDashboardCategories().then(response => {
        this.dashboardCategories = response;
      });
    },
    getCreations: function() {
      service.getCreations("").then(response => {
        this.loadingData = false;
        this.creations = response.creations;
      });
    },
    getFirstPaymentData: function () {
      service.getFirstPaymentData().then(response => {
        this.loadingFirstPaymentData = false;
        this.payments = response.payments;
      });
    },
    getFirstPaymentDataByMonth: function () {
      service.getFirstPaymentDataMonth().then(response => {
        this.loadingFirstPaymentData = false;
        this.paymentsMonth = response.payments;
      });
    }
  },
  created() {
    this.getDashboardData();
    //this.getDashboardCategories();
    this.getCreations();
    //this.getFirstPaymentData();
    //this.getFirstPaymentDataByMonth();
  },
  components: { Spinner, CreationList }
}
</script>


